import PropTypes from 'prop-types';

export const phonePropType = PropTypes.shape({
  number: PropTypes.string,
  phoneType: PropTypes.string,
  extension: PropTypes.string,
});

export const userSharedProps = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  phone: phonePropType,
  status: PropTypes.string,
  accessLevels: PropTypes.shape({
    accountAdmin: PropTypes.bool,
    projectAdmin: PropTypes.bool,
    executive: PropTypes.bool,
  }).isRequired,
};
